import React, { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';

const HaloContainer = ({ children, options }: { children: React.ReactNode, options?: MutationObserverInit }) => {
  const [showHalo, setShowHalo] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
        setShowHalo(true);
        const timer = setTimeout(() => setShowHalo(false), 500);
        return () => clearTimeout(timer);
    });

    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        attributes: false,
        subtree: true,
        ...options,
      });
    }
  }, [children]);

  return (
    <Box
      ref={containerRef}
      sx={{
        transition: 'box-shadow 0.5s ease-in-out',
        boxShadow: showHalo ? '0 0 10px 5px rgba(0, 123, 255, 0.5)' : 'none',
        width: '100%',
        height: '100%',
      }}
    >
      {children}
    </Box>
  );
};

export default HaloContainer;
